/* eslint-disable max-len */
export const DOCUMENT_TYPES_RAW = {
    'Stipulation of Interest': { deed: false, lease: false },
    'Stipulation of Interest (Surface Partition)': { deed: false, lease: false },
    'Affidavit': { deed: false, lease: false },
    'Affidavit and Election Not to Probate Will': { deed: false, lease: false },
    'Affidavit and Last Will and Testament': { deed: false, lease: false },
    'Affidavit and Probate Proceedings': { deed: false, lease: false },
    'Affidavit in Regards to Mineral Interest of Mary Frances Walker, Alex Walker, Jr; Milton Wayne Walker, Linda Sparks, and Francene Minchew': { deed: false, lease: false },
    'Affidavit of Adverse Possession': { deed: false, lease: false },
    'Affidavit of Extension of Lease': { deed: false, lease: false },
    'Affidavit of Extension of Leases': { deed: false, lease: false },
    'Affidavit of Fact': { deed: false, lease: false },
    'Affidavit of Heirship': { deed: false, lease: false },
    'Affidavit of Heirship & Will of George D. Pike': { deed: false, lease: false },
    'Affidavit of Heirship and Last Will and Testament': { deed: false, lease: false },
    'Affidavit of Heirship and Proof of Death': { deed: false, lease: false },
    'Affidavit of Heirships': { deed: false, lease: false },
    'Affidavit of Homestead': { deed: false, lease: false },
    'Affidavit of Identity': { deed: false, lease: false },
    'Affidavit of Interest & Stipulation of Interest': { deed: false, lease: false },
    'Affidavit of Legal Titleholder': { deed: false, lease: false },
    'Affidavit of Marital Status': { deed: false, lease: false },
    'Affidavit of Non-Development': { deed: false, lease: false },
    'Affidavit of Non-Development and Non-Payment of Rentals': { deed: false, lease: false },
    'Affidavit of Non-Development and Non-Production': { deed: false, lease: false },
    'Affidavit of Non-Establishment of Trust': { deed: false, lease: false },
    'Affidavit of Non-Production': { deed: false, lease: false },
    'Affidavit of Nondevelopment and Nonproduction': { deed: false, lease: false },
    'Affidavit of Ownership': { deed: false, lease: false },
    'Affidavit of Same Name': { deed: false, lease: false },
    'Affidavit of Small Succession': { deed: false, lease: false },
    'Affidavit of Trust Status': { deed: false, lease: false },
    'Affidavit of Use & Occupancy': { deed: false, lease: false },
    'Affidavit of Use & Possession': { deed: false, lease: false },
    'Affidavit/Death Certificate': { deed: false, lease: false },
    'Affidvit of Heirship': { deed: false, lease: false },
    'Affifdavit of Heirship': { deed: false, lease: false },
    'Beneficiary Affidavit & Death Certificate': { deed: false, lease: false },
    'Correction of Affidavit of Heirship': { deed: false, lease: false },
    'Death and Heirship Affidavit': { deed: false, lease: false },
    'Disclaimer': { deed: false, lease: false },
    'Heirship Affidavit': { deed: false, lease: false },
    'NOTE: SECOND PART OF AFFIDAVIT OF HEIRSHIP': { deed: false, lease: false },
    'Tenant\'s Affidavit': { deed: false, lease: false },
    'Affidavit for Transfer': { deed: false, lease: false },
    'Affidavit of Business Name Change': { deed: false, lease: false },
    'Affidavit for Transfer to Survivor': { deed: false, lease: false },
    'Affidavit of Commencement of Operations Club SE SMF JF': { deed: false, lease: false },
    'Affidavit of Noncompliance with Terms of Oil and Gas Lease': { deed: false, lease: false },
    'Affidavit of Facts Relating to Title': { deed: false, lease: false },
    'Affidavit as to Succession of Real Estate': { deed: false, lease: false },
    'Confirmation of No Interest in Oil & Gas': { deed: false, lease: false },
    'Affidavit Termination of Life Estate': { deed: false, lease: false },
    'Affidavit for Record of Cancellation of Oil & Gas Leases': { deed: false, lease: false },
    'Affidavit for Transfer on Death Beneficiary': { deed: false, lease: false },
    'Affidavit to Aid of Record of Title to Deed': { deed: false, lease: false },
    'Affidavit for Transfer and Record of Real Estate Inherited': { deed: false, lease: false },
    'Manufactured Home Affidavit of Affixation': { deed: false, lease: false },
    'Affidavit of Forfeiture': { deed: false, lease: false },
    'Transfer on Death Designation Affidavit': { deed: false, lease: false },
    'Affidavit for Transfer of Real Estate Inherited': { deed: false, lease: false },
    'Affidavit for Transfer of Survivorship Deed to a Surviving Spouse': { deed: false, lease: false },
    'Affidavit Notice of Claim and Preservation of Mineral Interest in Land': { deed: false, lease: false },
    'Affidavit of Noncompliance with Terms of Oil & Gas Lease': { deed: false, lease: false },
    'Affidavit of Non Development & Nonpayment of Rentals': { deed: false, lease: false },
    'Affidavit of Non-Payment of Delay Rentals': { deed: false, lease: false },
    'Affidavit Terminating Life Estate': { deed: false, lease: false },
    'Affidavit of Fact Relating to Title': { deed: false, lease: false },
    'Affidavit of Non-Development & Non-Payment of Rentals': { deed: false, lease: false },
    'Affidavit For Transfer of Survivorship Deed': { deed: false, lease: false },
    'Affidavit for Transfer on Death': { deed: false, lease: false },
    'Affidavit of Facts Related to Abandonment of Dormant Mineral Interest': { deed: false, lease: false },
    'Affidavit of Surviving Spouse or Joint Survivor': { deed: false, lease: false },
    'Affidavit Notice of Claim & Preservation of Mineral Interest in Land': { deed: false, lease: false },
    'AffidavitNotice of Claim and Preservation of Mineral Interest in land': { deed: false, lease: false },
    'Statement of Claim of Mineral Interest': { deed: false, lease: false },
    'Addendum to Trust Agreement': { deed: false, lease: false },
    'Agreement': { deed: false, lease: false },
    'Agreement not to Probate Will': { deed: false, lease: false },
    'Amendment to Warranty Deed with Vendor\'s Lien': { deed: true, lease: true },
    'Appointment of Co-Trustee': { deed: false, lease: false },
    'Appointment of Substitute Trustee': { deed: false, lease: false },
    'Appointment of Substitute Trustee and Notice of Trustee\'s Sale': { deed: false, lease: false },
    'Appointment of Trust and Mineral Deed': { deed: true, lease: true },
    'Contract': { deed: false, lease: false },
    'Contract of Sale and Purchase': { deed: false, lease: false },
    'Correction Agreement': { deed: false, lease: false },
    'Correction Partition Agreement': { deed: false, lease: false },
    'Family Settlement Agreement': { deed: false, lease: false },
    'Indenture': { deed: false, lease: false },
    'Irrevocable Trust': { deed: false, lease: false },
    'Irrevocable Trust Agreement': { deed: false, lease: false },
    'Memorandum to Operating Agreement and Financial Statement': { deed: false, lease: false },
    'Merger': { deed: true, lease: true },
    'Partition': { deed: false, lease: false },
    'Partition Agreement': { deed: false, lease: false },
    'POA': { deed: false, lease: false },
    'Power of Attorney': { deed: false, lease: false },
    'Ratification and Rental Division Order': { deed: false, lease: false },
    'Ratification of Unit Agreement': { deed: false, lease: false },
    'Removal & Appointment of Co-Trustee': { deed: false, lease: false },
    'Resignation and Conveyance of Trustee': { deed: false, lease: false },
    'Resolution': { deed: false, lease: false },
    'Revocation of Power of Attorney': { deed: false, lease: false },
    'Stipulation of Interest and Division Order Agreement for Payment of Delay Rentals': { deed: false, lease: false },
    'Subordination Agreement': { deed: false, lease: false },
    'Surface Partition': { deed: false, lease: false },
    'Trust Indenture': { deed: false, lease: false },
    'Unit Agreement': { deed: false, lease: false },
    'Model Form Recording Supplement to Operating Agreement & Financing Statement': { deed: false, lease: false },
    'Marriage Record': { deed: false, lease: false },
    'Amended Model Form Recording Supplement to Operating Agreement & Financing Statement': { deed: false, lease: false },
    'Land Contract': { deed: false, lease: false },
    'Grant of Option': { deed: false, lease: false },
    '2011 Robert Rish Family Irrevocable Trust Agreement, Memorandum of Trust': { deed: false, lease: false },
    'Ratification and Memorandum of Joint Operating Agreement': { deed: false, lease: false },
    'Trust Agreement': { deed: false, lease: false },
    'Land Installment Contract': { deed: false, lease: false },
    'Ratification & Memorandum of Joint Operating Agreement': { deed: false, lease: false },
    'Memorandum of Joint Operating Agreement': { deed: false, lease: false },
    'Memorandum of Option Agreement': { deed: false, lease: false },
    'Assignment': { deed: false, lease: false },
    'Assignment (Mineral Deed)': { deed: true, lease: true },
    'Assignment and Bill of Sale': { deed: false, lease: false },
    'Assignment and Bill of Sale without Warranty': { deed: false, lease: false },
    'Assignment of Mineral and Royalty Interest': { deed: true, lease: true },
    'Assignment of Oil and Gas Lease': { deed: false, lease: true },
    'Assignment of Oil and Gas Leases': { deed: false, lease: true },
    'Assignment of ORRI': { deed: false, lease: true },
    'Assignment of Overriding Royalty': { deed: false, lease: true },
    'Assignment of Overriding Royalty Interest': { deed: false, lease: true },
    'Assignment of Royalty and Overriding Royalty Interest': { deed: false, lease: true },
    'Assignment of Vendor\'s Lien': { deed: false, lease: false },
    'Assignment, Bill of Sale & Conveyance': { deed: false, lease: false },
    'Assignment/Trust Agreement': { deed: false, lease: false },
    'Correction Assignment of Overriding Royalty Interest': { deed: false, lease: false },
    'Partial Assignment of Oil and Gas Lease': { deed: false, lease: false },
    'Sale, Conveyance and Assignment of Mineral and Royalty Interest': { deed: false, lease: false },
    'Conveyance of Overriding Royalty Interest': { deed: false, lease: false },
    'Assignment & Conveyance of Oil & Gas Leases': { deed: false, lease: false },
    'Assignment of Overriding Royalty Interest in Oil & Gas Leases': { deed: false, lease: false },
    'Assignment, Bill of Sale and Conveyance': { deed: false, lease: false },
    'Assignment of Oil and Gas and other Leases': { deed: false, lease: false },
    'Partial Assignment of Oil & Gas Leases Without Warranty': { deed: false, lease: false },
    'Partial Re-Conveyance of ORRI and Amendment of Assignments of ORRI': { deed: false, lease: false },
    'Assignment of Oil & Gas Leases': { deed: false, lease: false },
    'Assignment of Royalty Interests': { deed: false, lease: false },
    'Amended & Restated Assignment, Bill of Sale, & Conveyance': { deed: false, lease: false },
    'Assignment of Oil and Gas Leases Conveyance': { deed: false, lease: false },
    'Assignment, Bill of Sale, & Conveyance': { deed: false, lease: false },
    'Amended and Restated Assignment, Bill of Sale and Conveyance': { deed: false, lease: false },
    'Assignment Bill of Sale and Conveyance': { deed: false, lease: false },
    'Assignment of Oil & Gas Leases Conveyance': { deed: false, lease: false },
    'Assignment of Overriding Royalties on Oil, Gas Leases': { deed: false, lease: false },
    'Assignment of Oil & Gas Lease': { deed: false, lease: false },
    'Amendment To Assignment of Overriding Royalty Interest': { deed: false, lease: false },
    'Assignment of Overriding Royalty Interests in Oil and Gas Lease': { deed: false, lease: false },
    'Assignment & Bill of Sale': { deed: false, lease: false },
    'Assignment of Overriding Royalty Interest in and to Oil & Gas Leases': { deed: false, lease: false },
    'Assignment of ORRI in Oil & Gas Leases': { deed: false, lease: false },
    'Assignment of Oil & Gas and other Leases': { deed: false, lease: false },
    'Assignment and Conveyance of Oil and Gas Leases': { deed: false, lease: false },
    'Re-recorded Assignment of Oil and Gas Leases Conveyance': { deed: false, lease: false },
    'Assignment ofOverriding Royalty Interest': { deed: false, lease: false },
    'Assignment of Overriding Royalty Interests': { deed: false, lease: false },
    'Assignment of Oil and Gas and Other Leases': { deed: false, lease: false },
    'Assignment, Bill of Sale, Conveyance': { deed: false, lease: false },
    'CC/Probate Application for Letters of Administration': { deed: false, lease: false },
    'Certificate': { deed: false, lease: false },
    'Certificate of Occupancy': { deed: false, lease: false },
    'Certification': { deed: false, lease: false },
    'Certificate of Transfer': { deed: false, lease: false },
    'Certificate of Correction': { deed: false, lease: false },
    'Certificate of Judgment for Transfer': { deed: false, lease: false },
    'Certificate of Amendment': { deed: false, lease: false },
    'Certificate of Judgment Lien Upon Land and Tenements': { deed: false, lease: false },
    'Certificate of Will Transfer of Real Estate': { deed: false, lease: false },
    'Certificate of Release': { deed: false, lease: false },
    'Certificate of Marriage': { deed: false, lease: false },
    'Certificate of Will': { deed: false, lease: false },
    'Certificate of Satisfaction': { deed: false, lease: false },
    'Certificate of Name Change': { deed: false, lease: false },
    'Certificate for Transfer of Real Estate': { deed: false, lease: false },
    'Marriage Certificate': { deed: false, lease: false },
    'Certificate of Transfer of Real Estate': { deed: false, lease: false },
    'Amended and Restated Assignmnt, Bill of Sale and Conveyance': { deed: false, lease: false },
    '118th District Court Child Custody Case': { deed: false, lease: false },
    'CC Divorce': { deed: false, lease: false },
    'CC Order': { deed: false, lease: false },
    'CC Probate': { deed: false, lease: false },
    'CC/Probate': { deed: false, lease: false },
    'Certified Copy - Probate': { deed: false, lease: false },
    'Certified Copy of 68th Judicial District Court of Dallas County, Cause No. 34455-C': { deed: false, lease: false },
    'Certified Copy of 68th Judicial District Court of Dallas County, Cause No. 34455-U': { deed: false, lease: false },
    'Certified Copy of Application and Letters Testamentary': { deed: false, lease: false },
    'Certified Copy of Appointment of Administrator': { deed: false, lease: false },
    'Certified Copy of Inheritance Tax Receipt': { deed: false, lease: false },
    'Certified Copy of Last Will and Testament': { deed: false, lease: false },
    'Certified Copy of Letters of Administration': { deed: false, lease: false },
    'Certified Copy of Petition for Bankruptcy': { deed: false, lease: false },
    'Certified Copy of Probate': { deed: false, lease: false },
    'Certified Copy of Probate Proceedings': { deed: false, lease: false },
    'Certified Copy of Probate Proceedings/Inventory': { deed: false, lease: false },
    'Certified Copy of Probate Proceedings/Will Dallas County No. 16363': { deed: false, lease: false },
    'Certified Copy Probate Proceedings': { deed: false, lease: false },
    'Chapter 11 Bankruptcy-Case #: 16-11390': { deed: false, lease: false },
    'Classification & Appraisment': { deed: false, lease: false },
    'Dallas County No. 16363': { deed: false, lease: false },
    'Probate': { deed: false, lease: false },
    'Probate - Administration of Estate': { deed: false, lease: false },
    'Probate Proceedings': { deed: false, lease: false },
    'Civil Suit': { deed: false, lease: false },
    'Estate by the Entireties with Survivorship': { deed: false, lease: false },
    'Guardianship Docket': { deed: false, lease: false },
    'Guardianship': { deed: false, lease: false },
    'Guardian Docket': { deed: false, lease: false },
    'Probate(Guardianship)': { deed: false, lease: false },
    'Suit': { deed: false, lease: false },
    'Journal Entry Confirming Sale, Ordering Deed, & Distributing Sale Proceeds': { deed: false, lease: false },
    'Appeal': { deed: false, lease: false },
    'Civil Complaint - Bankruptcy and Foreclosure': { deed: false, lease: false },
    'Court of Common Pleas': { deed: false, lease: false },
    'Journal EntryWrit of Possession': { deed: false, lease: false },
    'Partition Case': { deed: false, lease: false },
    'Declaration of Pooled Unit': { deed: false, lease: false },
    'Declaration of Pooled Unit - Dunkin Unit': { deed: false, lease: false },
    'Declaration of Pooled Unit-': { deed: false, lease: false },
    'Designation of Homestead': { deed: false, lease: false },
    'Designation of Pooled Unit': { deed: false, lease: false },
    'Designation of Unit': { deed: false, lease: false },
    'East Veelmoor Unit': { deed: false, lease: false },
    'Estill 35 Unit': { deed: false, lease: false },
    'First Amendment to Declaration of Pooled Unit - Dunkin Unit': { deed: false, lease: false },
    'Pooling Amendment Letter': { deed: false, lease: false },
    'Pooling Amendment to Oil, Gas and Mineral Lease': { deed: false, lease: false },
    'Ratification of Designation of Pooled Unit': { deed: false, lease: false },
    'Ratification of Unit Designation': { deed: false, lease: false },
    'Unit Designation': { deed: false, lease: false },
    'Second Amendment to Declaration & Notice of Pooled Unit Club SE SMF JF Unit': { deed: false, lease: false },
    'First Amendment to Declaration & Notice of Pooled Unit Club SE SMF JF Unit': { deed: false, lease: false },
    'Declaration & Notice of Pooled Unit Club SE SMF JF Unit': { deed: false, lease: false },
    'Declaration & Notice of Pooled Unit Club SE SMF JF': { deed: false, lease: false },
    'Declaration and Notice of Pooled UnitZimnox Unit': { deed: false, lease: false },
    'Second Amendment to Declaration & Notice of Pooled UnitCreamer Unit': { deed: false, lease: false },
    'Corrective Declaration & Notice of Pooled UnitCreamer Unit': { deed: false, lease: false },
    'Declaration & Notice of Pooled UnitCreamer Unit': { deed: false, lease: false },
    'Declaration and Notice of Pooled UnitFERGUSON NE SMF JF': { deed: false, lease: false },
    'Declaration and Notice of Pooled Unit(Giuliano Unit)': { deed: false, lease: false },
    'Second Amendment to Declaration and Notice of Pooled Unit(Giuliano Unit)': { deed: false, lease: false },
    'First Amendment to Declaration and Notice of Pooled Unit (GIULIANO UNIT)': { deed: false, lease: false },
    'Third Amendment to Declaration and Notice of Pooled Unit (GIULIANO UNIT)': { deed: false, lease: false },
    'First Amendment to Declaration and Notice of Pooled Unit North American Coal Gas Unit C': { deed: false, lease: false },
    'Declaration and Notice of Pooled Unit (GIULIANO UNIT)': { deed: false, lease: false },
    'Third Amendment to Declaration and Notice of Pooled Unit(Giuliano Unit)': { deed: false, lease: false },
    'Declaration of Pooled Unit North American Coal Gas Unit C': { deed: false, lease: false },
    'First Amendment to declaration and notice of pooled Unit(Giuliano Unit)': { deed: false, lease: false },
    'Declaration & Notice of Pooled UnitGiuliano Unit': { deed: false, lease: false },
    'Declaration & Notice of Pooled Unit': { deed: false, lease: false },
    'Second Amendment to Declaration and Notice of Pooled Unit (GIULIANO UNIT)': { deed: false, lease: false },
    'Declaration and Notice of Pooled UnitZIMNOX UNIT': { deed: false, lease: false },
    'Declaration & Notice of Pooled UnitPelegreen Farms South': { deed: false, lease: false },
    'First Amendment to Declaration & Notice of Pooled UnitCreamer Unit': { deed: false, lease: false },
    'Declaration of Trust': { deed: false, lease: false },
    'Declaration & Notice of Pooled UnitNolan S CRC JF Unit': { deed: false, lease: false },
    '(Quit Claim)': { deed: true, lease: true },
    'Administrator\'s Mineral Distribution Deeed': { deed: true, lease: true },
    'Administrators Mineral Distribution Deed': { deed: true, lease: true },
    'Assumption Deed': { deed: true, lease: true },
    'Assumption Warranty Deed': { deed: true, lease: true },
    'Cash Warranty Deed': { deed: true, lease: true },
    'Contract/Warranty Deed with Vendor\'s Lien': { deed: true, lease: true },
    'Conveyance of Oil, Gas and Other Mineral Rights': { deed: true, lease: true },
    'Correction Deed': { deed: true, lease: true },
    'Correction Distribution Deed': { deed: true, lease: true },
    'Correction Mineral and Royalty Conveyance': { deed: true, lease: true },
    'Correction Mineral Deed': { deed: true, lease: true },
    'Correction Mineral Deed and Conveyance': { deed: true, lease: true },
    'Correction Mineral Deed and Royalty Conveyance': { deed: true, lease: true },
    'Correction Quitclaim Deed': { deed: true, lease: true },
    'Correction Universal, County-Wide, Sale, Conveyance & Assignment of Mineral & Royalty Interest': { deed: true, lease: true },
    'Correction Warranty Deed': { deed: true, lease: true },
    'Correction Warranty Deed with Vendor\'s Lien': { deed: true, lease: true },
    'Correcton Deed': { deed: true, lease: true },
    'Countywide-Blanket Mineral Deed': { deed: true, lease: true },
    'Deed': { deed: true, lease: true },
    'Deed (Surface Estate Only)': { deed: true, lease: false },
    'Deed & Conveyance': { deed: true, lease: true },
    'Deed and Conveyance': { deed: true, lease: true },
    'Deed of Executive Rights': { deed: true, lease: false },
    'Deed with Vendors Lien': { deed: true, lease: true },
    'Deed without Warranty': { deed: true, lease: true },
    'Deed, Conveyance, and Assignment of Certain Surface, Minerals and Overriding Royalty': { deed: true, lease: true },
    'Distribution Deed': { deed: true, lease: true },
    'Distribution Deed & Bill of Sale': { deed: true, lease: true },
    'Distribution Deed and Bill of Sale': { deed: true, lease: true },
    'Exchange Deed': { deed: true, lease: true },
    'Executor\'s Deed': { deed: true, lease: true },
    'General Warranty Deed': { deed: true, lease: true },
    'General Warranty Mineral Gift Deed': { deed: true, lease: true },
    'Gift Deed': { deed: true, lease: true },
    'Gift Deed with Reservation of Life Estate': { deed: true, lease: true },
    'Gift Mineral and Royalty Deed': { deed: true, lease: true },
    'Gift Mineral Deed': { deed: true, lease: true },
    'Global Mineral Deed': { deed: true, lease: true },
    'Guardian\'s Deed': { deed: true, lease: true },
    'Indenture/Deed': { deed: true, lease: true },
    'Independent Executor and Trustee\'s Distribution Deed and Assignment of Mineral Interest, Leasehold Interest, and Overriding Royalty Interest': { deed: true, lease: true },
    'Individual and Executor\'s Deed': { deed: true, lease: true },
    'Mineral & Royalty Conveyance': { deed: true, lease: true },
    'Mineral & Royalty Deed': { deed: true, lease: true },
    'Mineral and Royalty Conveyance': { deed: true, lease: true },
    'Mineral and Royalty Deed': { deed: true, lease: true },
    'Mineral and Royalty Deed (Correction)': { deed: true, lease: true },
    'Mineral and Royalty Deed and Assignment and Conveyance of Mineral and Royalty Interest Including Overriding Royalty Interests': { deed: true, lease: true },
    'Mineral and Royalty Deed and Assignment of Overriding Royalty Interests': { deed: true, lease: true },
    'Mineral and Royalty Warranty Deed': { deed: true, lease: true },
    'Mineral and Water Rights Deed': { deed: true, lease: true },
    'Mineral Conveyance': { deed: true, lease: true },
    'Mineral Deed': { deed: true, lease: true },
    'Mineral Deed (correction)': { deed: true, lease: true },
    'Mineral Deed and Conveyance': { deed: true, lease: true },
    'Mineral Deed and Royalty Conveyance': { deed: true, lease: true },
    'Mineral Distribution Conveyance': { deed: true, lease: true },
    'Mineral Distribution Deed': { deed: true, lease: true },
    'Mineral Gift Deed with Reservation of Life Estate': { deed: true, lease: true },
    'Mineral Interest': { deed: true, lease: true },
    'Mineral Warranty Deed': { deed: true, lease: true },
    'Mineral, Royalty & Overriding Royalty Conveyance': { deed: true, lease: true },
    'Mineral, Royalty and Overriding Royalty Conveyance': { deed: true, lease: true },
    'Mineral, Royalty, and Overriding Royalty Conveyance': { deed: true, lease: true },
    'Mineral/Royalty Deed': { deed: true, lease: true },
    'Partial Relinquishment of Life Estate Mineral Interests': { deed: true, lease: false },
    'Partition Deed': { deed: true, lease: true },
    'Patent': { deed: true, lease: true },
    'Patent (Copy)': { deed: true, lease: true },
    'Patent/Grant': { deed: true, lease: true },
    'QCD': { deed: true, lease: true },
    'Quit Claim Deed': { deed: true, lease: true },
    'Quit Claim Mineral Deed and Conveyance': { deed: true, lease: true },
    'Quit-Claim Conveyance': { deed: true, lease: true },
    'Quit-Claim Deed': { deed: true, lease: true },
    'Quit-claim Deed': { deed: true, lease: true },
    'Quit-Claim Deed (Correction)': { deed: true, lease: true },
    'Quit-Claim Mineral and Royalty Deed and Assignment and Conveyance of Mineral and Royalty Interest Including Overriding Royalty Interests': { deed: true, lease: true },
    'Quit-Claim Mineral Deed': { deed: true, lease: true },
    'Quitclaim': { deed: true, lease: true },
    'Quitclaim Deed': { deed: true, lease: true },
    'Quitclaim Mineral Deed': { deed: true, lease: true },
    'Ratification of Deed': { deed: true, lease: true },
    'Ratification of Mineral Deed': { deed: true, lease: true },
    'Ratify/Deed': { deed: true, lease: true },
    'Sheriff\'s Deed': { deed: true, lease: true },
    'Sheriffs Deed': { deed: true, lease: true },
    'Special Warranty Deed': { deed: true, lease: true },
    'Special Warranty Mineral Deed': { deed: true, lease: true },
    'Stipulation and Cross-Conveyance of Ownership of Mineral Interest': { deed: true, lease: true },
    'Stipulation of Interest and Cross Conveyance': { deed: true, lease: true },
    'Stipulation of Interest and Cross-Conveyance': { deed: true, lease: true },
    'Stipulation of Interests and Cross Conveyance': { deed: true, lease: true },
    'Stipulation of Ownership of Mineral Interest': { deed: true, lease: true },
    'Substitute Trustee\'s Deed': { deed: true, lease: true },
    'Substitute Warranty Deed': { deed: true, lease: true },
    'Trustee Deed': { deed: true, lease: true },
    'Trustee\'s Deed': { deed: true, lease: true },
    'Universal, County Wide, Sale, Conveyance and Assignment of Mineral and Royalty Interests': { deed: true, lease: true },
    'Universal, County-Wide, Sale , Conveyance and Assignment of Mineral and Royalty Interest': { deed: true, lease: true },
    'Universal, County-Wide, Sale, Conveyance & Assignment of Mineral & Royalty Interest': { deed: true, lease: true },
    'Universal, County-Wide, Sale, Conveyance and Assignment of Mineral and Royalty Interest': { deed: true, lease: true },
    'Universal, County-wide, Sale, Conveyance, and Assignment of Mineral and Royalty Interest': { deed: true, lease: true },
    'Warranty Deed': { deed: true, lease: true },
    'Warranty Deed (Assumption of Vendor\'s Lien)': { deed: true, lease: true },
    'Warranty Deed (Assumption)': { deed: true, lease: true },
    'Warranty Deed (Surface)': { deed: true, lease: false },
    'Warranty Deed (Coal)': { deed: true, lease: true },
    'Warranty Deed w/ Vendor\'s Lien': { deed: true, lease: true },
    'Warranty Deed w/Vendor\'s Lien': { deed: true, lease: true },
    'Warranty Deed with Lien': { deed: true, lease: true },
    'Warranty Deed with Lien Assumption': { deed: true, lease: true },
    'Warranty Deed with Vendor\'s Lien': { deed: true, lease: true },
    'Warranty Deed with Vendor\'s Lien (Assumption)': { deed: true, lease: true },
    'Warranty Deed with Vendor\'s Lien (Correction)': { deed: true, lease: true },
    'WD': { deed: true, lease: true },
    'WDVL': { deed: true, lease: true },
    'Blanket Conveyance of Mineral Estate': { deed: true, lease: true },
    'Non-Participating Royalty Deed': { deed: true, lease: false },
    'NPRI Deed': { deed: true, lease: true },
    'Ratification/Confirmation Deed': { deed: true, lease: false },
    'Right of Way Deed': { deed: true, lease: false },
    'Right-of-Way Deed': { deed: true, lease: false },
    'Royalty Deed': { deed: true, lease: false },
    'Royalty Deed (Correction)': { deed: true, lease: false },
    'Royalty Deed (Non-Participating)': { deed: true, lease: false },
    'Royalty Deed (Non-Participating) Correction': { deed: true, lease: false },
    'Royalty Gift Deed': { deed: true, lease: false },
    'Royalty Quit Claim Deed': { deed: true, lease: false },
    'Special Royalty Deed': { deed: true, lease: false },
    'Term Non-Participating Royalty Deed': { deed: true, lease: true },
    'Term Royalty Deed': { deed: true, lease: true },
    'GLO Land Grant': { deed: true, lease: true },
    'Land Grant': { deed: true, lease: true },
    'Letter Patent': { deed: true, lease: true },
    'Ratification and Joining in of Conveyance': { deed: false, lease: false },
    'RD': { deed: false, lease: false },
    'Royalty Contract': { deed: false, lease: false },
    'SWD': { deed: true, lease: true },
    'Administratrix Deed': { deed: false, lease: false },
    'Warranty Deed (Love and Affection)': { deed: false, lease: false },
    'Warranty Deed with Dower': { deed: false, lease: false },
    'Warranty DeedSurvivorship': { deed: false, lease: false },
    'Special Warranty Oil & Gas Deed': { deed: false, lease: false },
    'Mineral Interest Deed': { deed: false, lease: false },
    'Warranty Deed(Coal)': { deed: true, lease: true },
    'Estate by the Entireties with Survivorship Deed': { deed: false, lease: false },
    'Administrative Deed': { deed: false, lease: false },
    'Deed and Conveyance of Production Payments': { deed: false, lease: false },
    'Warranty Deed-Survivorship': { deed: false, lease: false },
    'Special Corporate Warranty Deed': { deed: false, lease: false },
    'Survivorship Deed': { deed: false, lease: false },
    'Quit Claim': { deed: false, lease: false },
    'Administrator\'s Deed': { deed: false, lease: false },
    'Limited Warranty Deed': { deed: false, lease: false },
    'Fiduciary Deed': { deed: false, lease: false },
    'Auditor\'s Deed(Forfeited Land Sale)': { deed: false, lease: false },
    'Executrix Deed': { deed: false, lease: false },
    'Sheriff\'s Deed on Foreclosure on Unredeemed Delinquent Land Tax Certificate': { deed: false, lease: false },
    'Corrective Quit-Claim Mineral Deed': { deed: false, lease: false },
    'Warranty Deed (Easement)': { deed: false, lease: false },
    'Life Estate Deed': { deed: false, lease: false },
    'Sheriff\'s Deed in Partition': { deed: false, lease: false },
    'General Warranty Mineral Deed': { deed: false, lease: false },
    'Coal Deed': { deed: false, lease: false },
    'Quit Claim Deed, Assignment and Bill of Sale': { deed: false, lease: false },
    'Warranty Deed with Retention of Life Estate': { deed: false, lease: false },
    'Sheriff\'s Deed on Foreclosure': { deed: false, lease: false },
    'Quit Deed': { deed: false, lease: false },
    'Executor\'s  Deed': { deed: false, lease: false },
    'Sheriff\'s Deed on Foreclosure, on Delinquent Land Tax': { deed: false, lease: false },
    'Deed on Decree or Order of Sale': { deed: false, lease: false },
    'Limited Warranty Mineral Deed': { deed: false, lease: false },
    'Auditor\'s Deed (Forfeited Land Sale)': { deed: false, lease: false },
    'Executors Deed': { deed: false, lease: false },
    'Quit Claim Deed(Survivorship)': { deed: false, lease: false },
    'Quit Claim  Deed(OUTSALE)': { deed: false, lease: false },
    'Patent Deed': { deed: false, lease: false },
    'Second Patent Deed': { deed: false, lease: false },
    'Mortgage Warranty Deed': { deed: false, lease: false },
    'Warranty Deed With Rights Of Survivorship': { deed: false, lease: false },
    'Special Warranty Deed-Survivorship': { deed: false, lease: false },
    'Second Patent': { deed: false, lease: false },
    'Warranty DeedJoint and Survivorship': { deed: false, lease: false },
    'Joint & Survivorship Deed': { deed: false, lease: false },
    'General Warranty Survivorship Deed': { deed: false, lease: false },
    'Survivorship Warranty Deed': { deed: false, lease: false },
    'Executor\'sDeed': { deed: false, lease: false },
    'Receiver\'s Deed': { deed: false, lease: false },
    'Warranty Deed with Survivorship': { deed: false, lease: false },
    'Deed Limited': { deed: false, lease: false },
    'Warranty Deed with Rights of Survivorship': { deed: false, lease: false },
    'Quit Claim Deed(Releasing and Extinguishing Life Estate)': { deed: false, lease: false },
    'Warranty Deed-survivorship(OUTSALE)': { deed: false, lease: false },
    'Coal Warranty Deed': { deed: false, lease: false },
    'Warranty Deed(COAL)': { deed: false, lease: false },
    'Corrective Survivorship Deed': { deed: false, lease: false },
    'Sheriff Deed': { deed: false, lease: false },
    'Survivorship deed': { deed: false, lease: false },
    'SurvivorshipDeed': { deed: false, lease: false },
    'Warranty Deed(Survivorship)': { deed: false, lease: false },
    'GeneralWarranty Deed': { deed: false, lease: false },
    'Warranty Deed(Reserving Life Estate)': { deed: false, lease: false },
    'Guardian Deed': { deed: false, lease: false },
    'Warranty Deed- Survivorship': { deed: false, lease: false },
    'Warranty Deed(OUTSALE)': { deed: false, lease: false },
    'Amendment to Pipeline Easement': { deed: true, lease: false },
    'Easement': { deed: true, lease: false },
    'Easement and Right-of-Way': { deed: true, lease: false },
    'Pipeline Easement': { deed: true, lease: false },
    'Right of Way': { deed: true, lease: false },
    'Right-of-Way': { deed: true, lease: false },
    'Right-of-Way Easement': { deed: true, lease: false },
    'Temporary Pipeline Easement': { deed: true, lease: false },
    'Easement Right of Way': { deed: false, lease: false },
    'Deed of Easement': { deed: false, lease: false },
    'EasementRight of Way': { deed: false, lease: false },
    'Easement for Highway Purposes': { deed: false, lease: false },
    'Right of Way Easement': { deed: false, lease: false },
    'ROW': { deed: false, lease: false },
    'Right of Way Agreement': { deed: false, lease: false },
    'Pipeline Right of Way': { deed: false, lease: false },
    'Amendment & Ratification to Oil & Gas Lease': { deed: false, lease: true },
    'Amendment and Ratification to Paid Up Oil and Gas Lease': { deed: false, lease: true },
    'Amendment of Oil and Gas Lease': { deed: false, lease: true },
    'Amendment Oil & Gas Lease': { deed: false, lease: true },
    'Amendment to OGL': { deed: false, lease: true },
    'Amendment to Oil and Gas Lease': { deed: false, lease: true },
    'Amendment to Oil, Gas and Mineral Lease': { deed: false, lease: true },
    'Amendment to Oil, Gas, and Mineral Lease': { deed: false, lease: true },
    'Correction of Extension of Oil and Gas Lease': { deed: false, lease: true },
    'Extension of Oil & Gas Lease': { deed: false, lease: true },
    'Extension of Oil and Gas Lease': { deed: false, lease: true },
    'Lease': { deed: false, lease: true },
    'Lease Amendment and Revivor Agreement': { deed: false, lease: true },
    'Memo of OGL': { deed: false, lease: true },
    'Memorandum Giving Notice of Paid Up Oil and Gas Lease': { deed: false, lease: true },
    'Memorandum of Oil & Gas Lease': { deed: false, lease: false },
    'Memorandum of Oil and Gas Lease': { deed: false, lease: false },
    'Memorandum of Oil, Gas & Mineral Lease': { deed: false, lease: false },
    'Memorandum of Oil, Gas and Mineral Lease': { deed: false, lease: false },
    'Memorandum of Option to Acquire Oil, Gas and Mineral Lease': { deed: false, lease: false },
    'Memorandum of Paid Up Oil and Gas Lease': { deed: false, lease: true },
    'OGL': { deed: false, lease: true },
    'OGML': { deed: false, lease: true },
    'Oil & Gas Lease': { deed: false, lease: true },
    'Oil and Gas Lease': { deed: false, lease: true },
    'Oil and Gas Lease (Top Lease)': { deed: false, lease: true },
    'Oil and Gas Lease (Correction)': { deed: false, lease: true },
    'Oil, Gas & Mineral Lease': { deed: false, lease: true },
    'Oil, Gas and Mineral Lease': { deed: false, lease: true },
    'Oil, Gas and Mineral Lease (Top)': { deed: false, lease: true },
    'Oil, Gas or Mining Lease': { deed: false, lease: true },
    'Oil, Gas, and Mineral Lease': { deed: false, lease: true },
    'Oil,Gas and Mineral Lease': { deed: false, lease: true },
    'Partial Release of Oil and Gas Lease': { deed: false, lease: true },
    'Ratification': { deed: false, lease: true },
    'Ratification of an Oil and Gas Lease': { deed: false, lease: true },
    'Ratification of Oil and Gas Lease': { deed: false, lease: true },
    'Ratification of Oil, Gas & Mineral Lease': { deed: false, lease: true },
    'Ratification of Oil, Gas and Mineral Lease': { deed: false, lease: true },
    'Release': { deed: false, lease: true },
    'Release of OGL': { deed: false, lease: true },
    'Release of Oil and Gas Lease': { deed: false, lease: true },
    'Release of Oil, Gas or Mining Lease': { deed: false, lease: true },
    'Revivor and Extension of Oil and Gas Lease': { deed: false, lease: true },
    'Second Amendment to Oil and Gas Lease': { deed: false, lease: true },
    'Amendment & Extension of Oil & Gas Lease': { deed: false, lease: false },
    'Release of Oil & Gas Leases': { deed: false, lease: false },
    'Paid Up Oil & Gas Lease': { deed: false, lease: false },
    'Paid Up Oil and Gas Lease': { deed: false, lease: false },
    'Memorandum of Paid Up Oil & Gas Lease': { deed: false, lease: false },
    'Release of Oil and Gas Leases': { deed: false, lease: false },
    'Option to Lease': { deed: false, lease: false },
    'Memorandum of Lease Amendment': { deed: false, lease: false },
    'Partial Release of Oil & Gas Lease': { deed: false, lease: false },
    'Amended Memorandum of Lease': { deed: false, lease: false },
    'Cancellation of Oil & Gas Lease Agreements': { deed: false, lease: false },
    'Lease Agreement': { deed: false, lease: false },
    'Memorandum of Lease': { deed: false, lease: false },
    'Amendment and Ratification of Oil and Gas Lease': { deed: false, lease: false },
    'Paid-Up Oil and Gas Lease': { deed: false, lease: false },
    'Paid Up Lease': { deed: false, lease: false },
    'Notice of Extension of Oil and Gas Lease': { deed: false, lease: false },
    'Memorandum of Oil and Gas': { deed: false, lease: false },
    'Memorandumof Oil and Gas Lease': { deed: false, lease: false },
    'Release of Oil & Gas Lease': { deed: false, lease: false },
    'Memorandum of Oil & Gas lease': { deed: false, lease: false },
    'Amendment & Ratification of Oil & Gas Lease': { deed: false, lease: false },
    'Memorandum Oil and Gas Lease': { deed: false, lease: false },
    'Oil and Gas Lease Agreement': { deed: false, lease: false },
    'Memorandum of Lease Agreement': { deed: false, lease: false },
    'Memorandum of  Oil and Gas Lease': { deed: false, lease: false },
    'Memorandum of Oil & Gas Leases': { deed: false, lease: false },
    'Sixth Amendment to Oil and Gas Lease': { deed: false, lease: false },
    'Releases of Oil and Gas Leases': { deed: false, lease: false },
    'Extension of Vendor\'s Lien': { deed: false, lease: false },
    'Release of Lien': { deed: false, lease: false },
    'Release of Vendor\'s Lien': { deed: false, lease: false },
    'Release Vendor\'s Lien': { deed: false, lease: false },
    'Transfer Lien': { deed: false, lease: false },
    'Transfer of Lien': { deed: false, lease: false },
    'Transfer of Notes and Lien': { deed: false, lease: false },
    'Transfer of Vendor\'s Lien': { deed: false, lease: false },
    'Partial Release of Lien': { deed: false, lease: false },
    'Real Estate Lien': { deed: false, lease: false },
    'Foreclosure of Liens for Delinquent Land Taxes by Action in Rem': { deed: false, lease: false },
    'Foreclosure of Liens for Delinquent Land Taxes': { deed: false, lease: false },
    'Classification of Lands': { deed: false, lease: false },
    'Register': { deed: false, lease: false },
    'Articles of Amendment - Domestic Business Corporation': { deed: false, lease: false },
    'Death': { deed: false, lease: false },
    'Death Record': { deed: false, lease: false },
    'Marriage License': { deed: false, lease: false },
    'Death Information': { deed: false, lease: false },
    'Divorce': { deed: false, lease: false },
    'Commissioner\'s Journal': { deed: false, lease: false },
    'Family Record': { deed: false, lease: false },
    'Certificate of JPMorgan Chase Bank, National Association': { deed: false, lease: false },
    'Appropriation of Private Property for Public Use': { deed: false, lease: false },
    'Marriage': { deed: false, lease: false },
    'Petition in Partition of Realty': { deed: false, lease: false },
    'Durable Power of Attorney': { deed: false, lease: false },
    'Satisfaction Piece': { deed: false, lease: false },
    'Petition for Dower': { deed: false, lease: false },
    'Foreclosure': { deed: false, lease: false },
    'Petition for Partition': { deed: false, lease: false },
    'Administration Docket': { deed: false, lease: false },
    'Petition to Sell Wards Real Estate': { deed: false, lease: false },
    'Certified Copy of Trustee Deed': { deed: true, lease: true },
    'Deed of Trust': { deed: false, lease: false },
    'An Open End Mortgage, Security Agreement, Assignment of Production, Fixture Filing and Financing Statement and Recording Supplement': { deed: false, lease: false },
    'Open End Mortgage': { deed: false, lease: false },
    'Satisfaction of Mortgage by Separate Instrument': { deed: false, lease: false },
    'Mortgage': { deed: false, lease: false },
    'Open-end Mortgage, Assignment, Security Agreement, Fixture Filing, Financing Statement and As-Extracted Collateral Filing': { deed: false, lease: false },
    'Mortgage Release': { deed: false, lease: false },
    'Release of Real Estate Mortgage': { deed: false, lease: false },
    'First Amendment and Supplement to Open-End Mortgage, Assignment of As-Extracted Collateral, Security Agreement, Fixture Filing and Financing Statement': { deed: false, lease: false },
    'Mortgage Satisfaction': { deed: false, lease: false },
    'Release of Mortgage': { deed: false, lease: false },
    'Real Estate Mortgage': { deed: false, lease: false },
    'Release of Open End Mortgage': { deed: false, lease: false },
    'Open - End Mortgage': { deed: false, lease: false },
    'First Mortgage': { deed: false, lease: false },
    'Open -End Mortgage': { deed: false, lease: false },
    'Satisfaction of Mortgage': { deed: false, lease: false },
    'Mortgage Deed': { deed: false, lease: false },
    'Assignment of Mortgage/Deed of Trust': { deed: false, lease: false },
    'Ohio Mortgage': { deed: false, lease: false },
    'Full Satisfaction of Mortgage': { deed: false, lease: false },
    'Mortgage for Ohio': { deed: false, lease: false },
    'Open-End Mortgage': { deed: false, lease: false },
    'Open-End Mortgage, Assignment of As-Extracted Collateral, Security Agreement, Fixture Filing and Financing Statement': { deed: false, lease: false },
    'Release of Mortgages': { deed: false, lease: false },
    'Open End Real Estate Mortgage': { deed: false, lease: false },
    'Corporate Assignment of Mortgage': { deed: false, lease: false },
    'Release of Mortgage Deed': { deed: false, lease: false },
    'Ohio Open End Mortgage': { deed: false, lease: false },
    'Lis Pendens': { deed: false, lease: false },
    'Name Change': { deed: false, lease: false },
    'Notice': { deed: false, lease: false },
    'Notice of Change of Trustee': { deed: false, lease: false },
    'Notice of Child Support Lien': { deed: false, lease: false },
    'Notice of Extension of Oil & Gas Leases': { deed: false, lease: true },
    'Notice of Extension of Oil, Gas and Mineral Leases': { deed: false, lease: true },
    'Order': { deed: false, lease: false },
    'Order Appointing Permanent Guardian of the Estate and Person': { deed: false, lease: false },
    '118th District Court Order of Dismissal': { deed: false, lease: false },
    '118th District Court Tax Suit & Order of Dismissal': { deed: false, lease: false },
    'Certified Copy District Court Order': { deed: true, lease: true },
    'Certified Copy of Court Decree': { deed: true, lease: true },
    'Certified Copy of Judgment': { deed: true, lease: true },
    'Certified Copy of Judgment Declaring Heirship': { deed: true, lease: true },
    'Certified Copy of Order': { deed: true, lease: true },
    'Certified Copy of Probate Proceedings/Order': { deed: true, lease: true },
    'Decree of Partition': { deed: false, lease: false },
    'Judgement': { deed: false, lease: false },
    'Judgement (Partition)': { deed: false, lease: false },
    'Judgment': { deed: false, lease: false },
    'Last Will and Testament and Order Probating Will': { deed: false, lease: false },
    'Last Will and Testament/Order to Admit': { deed: false, lease: false },
    'Order Admitting Holographic Will': { deed: false, lease: false },
    'Order Admitting Will to Probate as a Muniment of Title': { deed: false, lease: false },
    'Order of Sale': { deed: false, lease: false },
    'Rental Division Order': { deed: false, lease: false },
    'Decree of Divorce': { deed: false, lease: false },
    'Decree of Dissolution': { deed: false, lease: false },
    'Court Order by LWT': { deed: false, lease: false },
    'Judgment Decree of Divorce': { deed: false, lease: false },
    'Death Certificate': { deed: false, lease: false },
    'Intelius': { deed: false, lease: false },
    'Ohio Secretary of State': { deed: false, lease: false },
    'Secretary of State': { deed: false, lease: false },
    'Plat Sub-division': { deed: false, lease: false },
    'Plat': { deed: false, lease: false },
    'Conveyance and Assignment of Mineral and Royalty Interest': { deed: false, lease: false },
    'Miner, Royalty and Overriding Royalty Conveyance': { deed: false, lease: true },
    'Miner, Royalty, and Overriding Royalty Conveyance': { deed: false, lease: true },
    'Quitclaim and Release': { deed: false, lease: false },
    'Release/Quitclaim': { deed: false, lease: false },
    'Conveyance': { deed: false, lease: false },
    'Indenture and Conveyance': { deed: false, lease: false },
    'Certified Copy of Will': { deed: false, lease: false },
    'Last Will and Testament': { deed: false, lease: false },
    'Will': { deed: false, lease: false },
    'Last Will & Testament': { deed: false, lease: false },
}
/* eslint-enable max-len */

export const categorizeDocument = instrumentType => {
    const hasRaw = DOCUMENT_TYPES_RAW[instrumentType] || DOCUMENT_TYPES_RAW[instrumentType.toLowerCase()]
    
    if (hasRaw) return hasRaw
    
    if (instrumentType.toLowerCase().includes('deed')) {
        return { deed: true, lease: false }
    } else if (instrumentType.toLowerCase().includes('lease')) {
        return { deed: false, lease: true }
    }
    
    return { deed: false, lease: false }
}


